import { CommunicationSizeComponent, ComponentIds } from '@inter-ikea-core/core';
import { CoreApi, ProductInfoComponent, ProductType } from '@inter-ikea-storageone/range';
import { store } from 'ducks';

export const findMatchingFrameWithDifferentDepth = (coreApi: CoreApi) => {
  const selectedFrame = coreApi.entities.findSelectedEntity();
  const products = store.getState().products.inMarket;

  const frames = products.filter(p => p.type === ProductType.BILLY_FRAME_WITH_SHELVES_ASM);

  const relevantFrames = frames?.filter(frame => {
    const selectedFrameDesign = selectedFrame?.getComponent<ProductInfoComponent>(
      ProductInfoComponent.id
    )?.design;

    const selectedFrameDimensions = selectedFrame?.getComponent<CommunicationSizeComponent>(
      ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID
    )?.size;

    return (
      frame.communicatedDimensions?.width === selectedFrameDimensions?.width &&
      frame.communicatedDimensions?.height === selectedFrameDimensions?.height &&
      frame.communicatedDimensions?.depth !== selectedFrameDimensions?.depth &&
      frame.design === selectedFrameDesign
    );
  });

  const newFrame = relevantFrames?.[0];

  return newFrame;
};
